import React, { useEffect, useRef, useState } from 'react';

const DesktopMenuItem = ({ item, depth = 1 }) => {
  const [open, setOpen] = useState(false);
  const itemRef = useRef();
  const submenuRef = useRef();

  const hasChildren = item.children?.length > 0;

  // Click-outside closes this submenu
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (itemRef.current && !itemRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // When opened, move focus to the first link
  useEffect(() => {
    if (open && submenuRef.current) {
      const firstLink = submenuRef.current.querySelector('a');
      firstLink?.focus();
    }
  }, [open]);

  // Handle Escape and Shift+Tab inside the submenu
  const handleSubMenuKeyDown = (e) => {
    // If Escape, close submenu and return focus to toggle
    if (e.key === 'Escape') {
      e.preventDefault();
      setOpen(false);
      itemRef.current.querySelector('.submenu-toggle')?.focus();
    }
    // If Shift+Tab on the first link of this submenu, close and return focus to parent <a>
    if (e.key === 'Tab' && e.shiftKey) {
      const firstLink = submenuRef.current.querySelector('a');
      if (document.activeElement === firstLink) {
        e.preventDefault();
        setOpen(false);
        itemRef.current.querySelector('a')?.focus();
      }
    }
  };

  return (
    <li
      ref={itemRef}
      className={open ? 'open' : ''}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* Main link */}
      <a href={item.href} role="menuitem">
        {item.title}
      </a>

      {hasChildren && (
        <>
          {/* Toggle button */}
          <button
            className="submenu-toggle"
            aria-haspopup="true"
            aria-expanded={open}
            onClick={(e) => {
              e.preventDefault();
              setOpen((prev) => !prev);
            }}
          >
            <i
              className={`fa fa-chevron-${depth === 1 ? 'down' : 'right'}`}
              aria-hidden="true"
            ></i>
          </button>

          {/* Submenu */}
          <ul
            role="menu"
            ref={submenuRef}
            onKeyDown={handleSubMenuKeyDown}
          >
            {item.children.map((child) => (
              <DesktopMenuItem
                key={child.title}
                item={child}
                depth={depth + 1}
              />
            ))}
          </ul>
        </>
      )}
    </li>
  );
};

export default DesktopMenuItem;

